import { useTranslation } from 'react-i18next';

export const NotFound = () => {
  const { t } = useTranslation(['errors']);
  return (
    <>
      <span>{t('errors:http_404')}</span>
    </>
  );
};
